import PropTypes from 'prop-types';
import StatisticsCount from '../../common/StatisticsCount';

/** 主阶段单数钻取：点击后筛选下方订单列表 */
const OrderPrimaryPhaseOrderCountLink = ({ count, phase, selectedPhase, onSelectPhase, className = '', suffix = ' 单', loading = false, animate = true }) => {
	const numericCount = Number(count) || 0;

	if (numericCount <= 0 || !onSelectPhase) {
		return (
			<span className={className}>
				{animate && !loading ? (
					<StatisticsCount value={numericCount} suffix={suffix} className='' duration={1.1} />
				) : (
					`${numericCount}${suffix}`
				)}
			</span>
		);
	}

	const isSelected = selectedPhase === phase;

	return (
		<button
			type='button'
			className={['order-primary-phase__count-link', isSelected ? 'is-selected' : '', className].filter(Boolean).join(' ')}
			onClick={() => onSelectPhase(phase)}
			aria-pressed={isSelected}
		>
			{animate && !loading ? <StatisticsCount value={numericCount} suffix={suffix} duration={1.1} /> : `${numericCount}${suffix}`}
		</button>
	);
};

OrderPrimaryPhaseOrderCountLink.propTypes = {
	count: PropTypes.number,
	phase: PropTypes.string,
	selectedPhase: PropTypes.string,
	onSelectPhase: PropTypes.func,
	className: PropTypes.string,
	suffix: PropTypes.string,
	loading: PropTypes.bool,
	animate: PropTypes.bool,
};

export default OrderPrimaryPhaseOrderCountLink;
